module.exports = __webpack_public_path__ + "static/media/builtinv2-Panely upravlenia (1).efd82595.png";